import jobs from './jobs';
import projects from './projects';

/**
 * DataService handles all the communication with any data sources
 */
export const DataService = function() {
  function buildMarkdownURL(id) {
    return `./../markdown/${id}.md`;
  }

  function buildImageURL(id) {
    return `../images/${id}.jpg`;
  }

  function fetchJobs() {
    return Promise.resolve(jobs);
  }

  function fetchProjects() {
    return Promise.resolve(projects);
  }

  function fetchProjectDetails(id) {
    if (projects.filter(p => p.id === id).length === 0) {
      return Promise.reject('No such project');
    }
    return fetch(buildMarkdownURL(id))
      .then(response => response.text())
      .then(textResponse => {
        return Promise.resolve({
          id: { id },
          markdown: textResponse,
          coverImg: buildImageURL(id)
        });
      });
  }

  return Object.freeze({
    fetchJobs,
    fetchProjects,
    fetchProjectDetails
  });
};
